import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationComponent } from './registration.component';
import { SharedModule } from '../../shared/shared.module';
import { UserProfilTypeComponent } from './user-profil-type/user-profil-type.component';
import { DsrIconsModule } from '@desyre/icons-angular';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RegistrationService } from './registration.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [
        RegistrationComponent,
        UserProfilTypeComponent
    ],
    exports: [
        RegistrationComponent
    ], 
    imports: [CommonModule,
        SharedModule,
        DsrIconsModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatInputModule,
        MatCheckboxModule,
        MatRadioModule,
        MatButtonModule,
        RouterModule,
        MatFormFieldModule,
        TranslateModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatTooltipModule
    ], 
    providers: [
        RegistrationService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})

export class RegistrationModule { }